(() => {
  const setQuantity = (qty) => {
    const value = Number(qty);
    if (!value || value < 1) return false;

    const inputs = document.querySelectorAll('.m-product-form--main input[name="quantity"], m-quantity-input input[name="quantity"]');
    if (!inputs.length) return false;

    inputs.forEach((input) => {
      input.value = value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });

    return true;
  };

  const selectTier = (root, qty) => {
    root.querySelectorAll(".m-volume-reward__tier").forEach((tier) => {
      const selected = tier.getAttribute("data-volume-qty") === String(qty);
      tier.classList.toggle("is-selected", selected);
      tier.setAttribute("aria-pressed", selected ? "true" : "false");
    });
  };

  const bind = (root) => {
    if (root.dataset.volumeBound === "true") return;
    root.dataset.volumeBound = "true";

    root.querySelectorAll("[data-volume-qty]").forEach((button) => {
      button.addEventListener("click", (event) => {
        const qty = button.getAttribute("data-volume-qty");
        selectTier(root, qty);

        if (button.tagName === "A" && button.getAttribute("href")) return;

        const changed = setQuantity(qty);
        if (!changed) return;
        event.preventDefault();
      });
    });
  };

  document.querySelectorAll("[data-volume-reward]").forEach(bind);
})();
